module.exports = "/_next/static/images/97eaed1b90b1ef68507c818c742ec57d-digital-account-phone-main-screen@xs-2x.png";